// src/components/DynamicSuccess.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography } from '@mui/material';

const providerNames: Record<string, string> = {
	jobadder: 'JobAdder',
	bullhorn: 'Bullhorn',
	vincere: 'Vincere',
};

const DynamicSuccess = ({ provider }: { provider: string }) => {
	const displayName = providerNames[provider] || 'your ATS integration';

	// Send OAuth completion message to parent window
	React.useEffect(() => {
		console.log(`OAuth success page loaded for provider: ${provider}`);

		// Send message to parent window about OAuth completion
		if (window.opener && !window.opener.closed) {
			window.opener.postMessage(
				{
					type: 'OAUTH_COMPLETED',
					source: 'refme_oauth',
					provider: provider,
				},
				'*'
			);
			console.log(
				`OAuth completion message sent to parent for provider: ${provider}`
			);
		}
	}, [provider]);

	return (
		<div className='flex h-screen items-center justify-center bg-gray-100 p-4'>
			<Card className='w-full max-w-xl rounded-2xl shadow-lg'>
				<CardContent className='space-y-4 p-8 text-center'>
					<Typography
						variant='h2'
						component='h2'
						className='font-semibold'
					>
						🎉 Integration Successfully!
					</Typography>
					<Typography
						variant='body1'
						className='text-lg text-gray-700'
					>
						You may now close this tab and use the {displayName} add-on to start
						the reference check.
					</Typography>
				</CardContent>
			</Card>
		</div>
	);
};

export default DynamicSuccess;
